import OtpInput from "react-otp-input";
import Buttons from "../../../components/Buttons/Buttons";

const UserFormOtpModal = ({ dialogRef, otp, onOtpChange, onCancel, onVerify, isLoading }) => (
  <dialog
    ref={dialogRef}
    className="otp-modal"
    aria-labelledby="otp-modal-title"
  >
    <h2 id="otp-modal-title">OTP Verification</h2>
    <p style={{ color: "#666666", marginBottom: "30px" }}>
      Enter the 6-digit OTP sent to your registered email
    </p>

    <OtpInput
      value={otp}
      onChange={onOtpChange}
      numInputs={6}
      inputType="tel"
      shouldAutoFocus
      renderInput={(props) => <input {...props} />}
      containerStyle={{
        display: "flex",
        justifyContent: "center",
        gap: "10px",
        marginBottom: "30px",
      }}
      inputStyle={{
        width: "50px",
        height: "50px",
        fontSize: "24px",
        textAlign: "center",
        border: "1px solid #e3e3e3",
        borderRadius: "8px",
        outline: "none",
      }}
    />

    <div
      style={{
        display: "flex",
        gap: "15px",
        justifyContent: "center",
      }}
    >
      <Buttons
        text="Cancel"
        type="button"
        variant="secondary"
        fullWidth={false}
        onClick={onCancel}
        style={{ padding: "10px 30px" }}
      />
      <Buttons
        text={isLoading ? "Verifying..." : "Verify OTP"}
        type="button"
        variant="primary"
        fullWidth={false}
        onClick={onVerify}
        disabled={isLoading || otp.length !== 6}
        style={{ padding: "10px 30px" }}
      />
    </div>
  </dialog>
);

export default UserFormOtpModal;
